import React from 'react';
import { Badge } from '../ui/badge';

// Escala de color por score (0-100): >=70 verde, 40-69 ámbar, 1-39 rojo,
// 0/sin puntuar gris — mismo criterio de "alta/media/baja/sin puntuar"
// que scoring.schema.json usa para priority, aplicado visualmente al score.
export function ScoreBadge({ score }) {
  const value = typeof score === 'number' ? score : 0;
  let colorClass = 'bg-zinc-800 text-zinc-400 border-zinc-700';
  if (value >= 70) colorClass = 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30';
  else if (value >= 40) colorClass = 'bg-amber-500/10 text-amber-400 border-amber-500/30';
  else if (value > 0) colorClass = 'bg-red-500/10 text-red-400 border-red-500/30';

  return (
    <Badge variant="outline" className={`font-mono tabular-nums ${colorClass}`}>
      {value}
    </Badge>
  );
}
